export default {
  de: {
    title: 'Neue Leistungskategorie hinzufügen',
    name: 'Name',
    submit: 'Kategorie erstellen',
    back: 'Zurück',
    alerts: {
      500: () => 'Ein unbekannter Fehler ist aufgetretten! Bitte versuchen Sie es in kürze erneut!',
    },
  },
};
